module.exports = __webpack_public_path__ + "img/match1.01a1bb5b.jpg";